<template>
  <v-sheet
    class="summary-item mt-5 text-left d-flex text-decoration-none"
    min-height="84"
    width="190"
    rounded
    elevation="3"
    tag="div"
    @click="href && href !== $route.path ? $router.push(href) : true"
  >
    <v-container class="pa-0 d-inline-flex">
      <v-row
        no-gutters
        align="center"
      >
        <v-col cols="auto">
          <v-sheet class="summary-icon pa-2">
            <v-img
              :class="status"
              contain
              :src="summaryContent.img"
              width="60"
            ></v-img>
            <div class="font-weight-bold text-caption white--text">
              {{summaryContent.title}}
            </div>
          </v-sheet>
        </v-col>
        <v-col
          class="text-center"
          :class="!!summaryContent.caption ? 'with-caption': ''"
        >
          <span class="font-weight-bold text-h4 summary-count">
            {{count}}
          </span>
          <br>
          <span
            v-if="summaryContent.caption"
            class="font-weight-bold text-body-2 grey--text subtitle-1 text-caption"
          >
            {{summaryContent.caption}}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'new',
    },
    count: {
      type: [String, Number],
      default: '9999+',
    },
  },
  computed: {
    summaryContent() {
      switch (this.status) {
        case 'new':
          return {
            title: 'Order Baru',
            img: require('../../assets/images/order-new.png'),
          };
        case 'problem':
          return {
            title: 'Kendala',
            img: require('../../assets/images/order-problem.png'),
          };
        case 'pickup':
          return {
            title: 'Jemput',
            img: require('../../assets/images/order-pickup.png'),
            caption: '7 Hari Terakhir',
          };
        case 'delivery':
          return {
            title: 'Kirim',
            img: require('../../assets/images/order-delivery.png'),
            caption: '7 Hari Terakhir',
          };
        case 'complete':
          return {
            title: 'Selesai',
            img: require('../../assets/images/order-complete.png'),
            caption: '7 Hari Terakhir',
          };
        default:
          return {
            title: 'Order Baru',
            img: require('../../assets/images/order-new.png'),
            caption: '7 Hari Terakhir',
          };
      }
    },
  },
};
</script>

<style lang="scss">
.summary-item {
  cursor: pointer;
  .summary-icon {
    width: 84px;
    height: 84px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    background-color: #02499a;
  }
  .with-caption {
    margin-bottom: -15px;
  }
}
</style>
